<!-- Comentado menú superior para evitar que usuario pueda cambiar de página -->
<!-- <app-menu-superior [user]="user" [button]="false" [title]="'ACTUALIZAR'"></app-menu-superior> -->

<ion-content class="bg-content">
  <ion-grid>
    <ion-row class="msg-update">
      <ion-col size="12">
        Hay una nueva versión disponible para la aplicación. Es necesario actualizar para poder usar la aplicación.
      </ion-col>
    </ion-row>
    <ion-row *ngIf="errorMessage" class="msg-update">
      <ion-col size="12">{{errorMessage}}</ion-col>
    </ion-row>
    <ion-row *ngIf="!errorMessage" class="new-version" (click)="getNewVersion()">
      <ion-col size="2">
        <div class="bounce2">
          <fa-icon [icon]="faService.faDownload" style="font-size: 50px;"></fa-icon>
        </div>
      </ion-col>
      <ion-col size="10">
        <ion-label>Descargar versión <strong>{{onlineVersion}}</strong></ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>